import MuiButton from './MuiButton'
import MuiCard from './MuiCard'
import MuiLink from './MuiLink'
import MuiCssBaseline from './MuiCssBaseline'
import MuiFormLabel from './MuiFormLabel'

const overrides = {
  MuiButton,
  MuiCard,
  MuiLink,
  MuiCssBaseline,
  MuiFormLabel,
}

export default overrides
